import { graphql, useStaticQuery } from 'gatsby';

const useSTCP = () => {
  const { allAirtableStcp } = useStaticQuery(graphql`
    {
      allAirtableStcp {
        nodes {
          data {
            About
            Business_Name
            Email
            Who_is_the_main_point_of_contact_for_your_company_
            Website
            STCP_Type
            What_trade_s__do_you_have_experience_knowledge_of_
            Certification_Date(formatString: "MM/DD/yy")
            Phone
          }
        }
      }
    }
  `);

  return allAirtableStcp.nodes.map((node) => node.data);
};

export default useSTCP;
